import { UserDomainWithWebsiteInterface, WebsiteInterface } from '../types/website-interface'
import { formUrl } from 'shared/utils/links/form-url'

export const getUrlWebsiteEdit = (pageContentId: number) => {
  return formUrl(`/websites/page/${pageContentId}/edit`)
}

export const getUrlWebsiteView = (
  website: WebsiteInterface,
  userDomainsWithWebsite?: UserDomainWithWebsiteInterface[],
) => {
  if (website.active) {
    const domainName = userDomainsWithWebsite?.find(el => el.id === website.domainId)?.name

    return `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domainName}/${website.homePagePath}`
  }
  if (website.homePage) return `${getUrlWebsiteEdit(website.homePage.pageContentId)}?preview=true`

  return ''
}
